<div class="container" [ngStyle]="{'flex-direction': (sideVideo=='left') ? 'row' : 'row-reverse'}">
    <div class="content">
        <p class="subtitle">{{subtitle}}</p>
        <h3>{{title}}</h3>
        <p class="text">{{text}} </p>
    </div>
    <div class="video">
        <iframe loading="lazy" width="1280" height="728" [src]="url | safe" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
</div>